import { render, staticRenderFns } from "./ResetStudentPassword.vue?vue&type=template&id=07b33030&scoped=true&"
import script from "./ResetStudentPassword.vue?vue&type=script&lang=js&"
export * from "./ResetStudentPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetStudentPassword.vue?vue&type=style&index=0&id=07b33030&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b33030",
  null
  
)

component.options.__file = "ResetStudentPassword.vue"
export default component.exports